import * as React from 'react';
import { NavLink as RouterNavLink } from 'react-router-dom';

const NavLink = React.forwardRef<any, any>((props, ref) => (
  <RouterNavLink
    ref={ref}
    to={props.to}
    className={({ isActive }) =>
      `${props.className} ${isActive ? props.activeClassName : ''}`
    }
  >
    {props.children}
  </RouterNavLink>
));

export default NavLink;
